import { render } from "./bancard.vue?vue&type=template&id=3529f2d2"
import script from "./bancard.vue?vue&type=script&lang=js"
export * from "./bancard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__